module.exports = __webpack_public_path__ + "static/media/2.5eef244d.png";